import { render } from "./userActivity.vue?vue&type=template&id=284b510e"
import script from "./userActivity.vue?vue&type=script&lang=js"
export * from "./userActivity.vue?vue&type=script&lang=js"

import "./userActivity.vue?vue&type=style&index=0&id=284b510e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__